import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets.app/images/logo.svg'
import _imports_1 from '@/assets.app/images/onboarding/trial-stars.svg'
import _imports_2 from '@/assets.app/images/onboarding/trial-arrow.svg'


const _hoisted_1 = { class: "onboarding-trial__header" }
const _hoisted_2 = { class: "layout__wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "onboarding-trial__periods"
}
const _hoisted_4 = { class: "onboarding-trial__period" }
const _hoisted_5 = {
  key: 0,
  src: _imports_2,
  class: "onboarding-trial__arrow"
}
const _hoisted_6 = { class: "onboarding-trial__period-header" }
const _hoisted_7 = { class: "onboarding-trial__period-text" }
const _hoisted_8 = { class: "onboarding-trial__period-steps" }
const _hoisted_9 = { class: "onboarding-trial__period onboarding-trial__period--monthly" }
const _hoisted_10 = { class: "onboarding-trial__period-header" }
const _hoisted_11 = { class: "onboarding-trial__period-text onboarding-trial__period-text--monthly" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "onboarding-trial__period-steps" }
const _hoisted_15 = {
  key: 1,
  class: "onboarding-trial__steps"
}
const _hoisted_16 = { class: "onboarding-trial__step-icon-wrapper" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "onboarding-trial__step-text-wrapper" }
const _hoisted_19 = { class: "onboarding-trial__step-icon-label" }
const _hoisted_20 = { class: "onboarding-trial__step-text" }
const _hoisted_21 = ["src", "width", "height"]
const _hoisted_22 = {
  key: 0,
  class: "onboarding-trial__date"
}
const _hoisted_23 = { class: "onboarding-trial__date-text" }
const _hoisted_24 = { class: "onboarding-trial__button-wrapper" }

import { computed, onBeforeMount, ref } from 'vue'
import AppButton from '@/app/components/button/AppButton.vue'
import { onboardingPages } from '@/models/onboarding.pages'
import { getImage } from '@/models/onboarding'
import Layout from '../Layout.vue'
import {
  iosExternalLinkPayment16218Experiment,
  trialByPlan15535Variant,
} from '@/services/ab'
import {
  getTrialByPlanVariantConfig,
  getTrialPolicy,
  PlatformTrialPolicy,
  trialByPlan15535Treatment,
  TrialByPlanExperimentVariantConfig,
} from '@/services/ab/15535_trial_by_plan'
import { platform } from '@/services/platform'
import { TrialStep } from '@/models/onboarding.types'
import { assertNotNull } from '@/helpers/typing'
import StepItem from '@/app/components/onboarding/trial/StepItem.vue'
import Divider from '@/components/ui/Divider.vue'
import { useWait } from '@/app/composables/useWait'


export default /*@__PURE__*/_defineComponent({
  __name: 'Trial',
  props: {
    nextOnboardingPage: { type: Function }
  },
  setup(__props: any) {

const props = __props

const pageIndex = ref<number>(0)

const page = computed(() => onboardingPages.trial[pageIndex.value])
const isLastPage = computed(
  () => pageIndex.value + 1 === onboardingPages.trial.length,
)

const pageImage = computed(() => {
  if (page.value.image) {
    return getImage(page.value.image.src)
  }
  return ''
})

const trialDays = computed((): { annual: number; monthly: number } => {
  if (trialConfig.value) {
    return {
      annual: trialConfig.value.annual[platformString.value].trial_days ?? 0,
      monthly: trialConfig.value.monthly[platformString.value].trial_days ?? 0,
    }
  }
  return { annual: 0, monthly: 0 }
})

const calculateStepDay = (index: number, trialDays: number): string => {
  if (index === 0) {
    return 'Today'
  }
  if (index === 1) {
    return 'Day ' + String(trialDays - 2)
  }
  return 'Day ' + String(trialDays)
}

const createAnnualSteps = (
  allSteps: TrialStep[],
  trialDays: number,
): TrialStep[] => {
  return allSteps.map((step, index) => ({
    ...step,
    day: calculateStepDay(index, trialDays),
  }))
}

const createMonthlySteps = (
  allSteps: TrialStep[],
  trialDays: number,
): TrialStep[] => {
  if (trialDays === 0) {
    return [
      {
        ...allSteps[allSteps.length - 1],
        day: 'Today',
        text: "Immediately access all of Shortform's content",
      },
    ]
  }

  return allSteps.map((step, index) => ({
    ...step,
    day: calculateStepDay(index, trialDays),
  }))
}

const trialSteps = computed(
  (): { annual: TrialStep[]; monthly: TrialStep[] } => {
    const allSteps = assertNotNull(page.value.steps)

    return {
      annual: createAnnualSteps(allSteps, trialDays.value.annual),
      monthly: createMonthlySteps(allSteps, trialDays.value.monthly),
    }
  },
)

const variantTitle = computed((): string => {
  if (trialPolicy.value && trialPolicy.value.trial_days === null) {
    if (pageIndex.value === 0) {
      return (
        page.value.title +
        '.<br/><span class="onboarding-trial__title-span"> For <u>Annual plans</u> only.</span>'
      )
    }

    return (
      page.value.title +
      '<span class="onboarding-trial__title-span"> For annual plans only.</span>'
    )
  }

  return page.value.title
})

const buttonClick = (): void => {
  if (isLastPage.value) {
    props.nextOnboardingPage()
    return
  }

  pageIndex.value++
}

const reminderDate = (): string => {
  const date = new Date()
  date.setDate(date.getDate() + 3)

  // Format the date to something like `December 18`
  const formatter = new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
  })
  return formatter.format(date)
}

const wait = useWait()
const trialPolicy = ref<PlatformTrialPolicy | null>(null)
const trialConfig = ref<TrialByPlanExperimentVariantConfig | null>(null)
const platformString = ref<'web' | 'ios'>('web')
onBeforeMount(async () => {
  wait.start('Loading')
  platformString.value = (await platform.isNativeIOSApp()) ? 'ios' : 'web'
  const variant = trialByPlan15535Variant() || 'A'
  if (variant) {
    trialPolicy.value = await getTrialPolicy(variant, 'monthly')
    trialConfig.value = getTrialByPlanVariantConfig(variant)
  }
  if (platformString.value === 'ios') {
    await iosExternalLinkPayment16218Experiment()
  }
  wait.end('Loading')
})

return (_ctx: any,_cache: any) => {
  const _component_loading_spinner = _resolveComponent("loading-spinner")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["onboarding-trial", [
      'onboarding-trial--page-' + pageIndex.value,
      { 'onboarding-trial--ab15535': _unref(trialByPlan15535Treatment)() },
    ]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[4] || (_cache[4] = _createElementVNode("img", {
        class: "onboarding-trial__logo",
        src: _imports_0
      }, null, -1)),
      _createElementVNode("button", {
        class: "onboarding-trial__close onboarding-trial__close--header",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.nextOnboardingPage && __props.nextOnboardingPage(...args)))
      }, [...(_cache[3] || (_cache[3] = [
        _createElementVNode("span", { class: "iconfont iclose-thin" }, null, -1)
      ]))])
    ]),
    (_unref(wait).is('Loading'))
      ? (_openBlock(), _createBlock(Layout, {
          key: 0,
          title: "",
          class: "onboarding-trial__inner--steps"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_loading_spinner)
            ])
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_Transition, {
          key: 1,
          name: "fade",
          mode: "out-in",
          class: "onboarding-trial__inner"
        }, {
          default: _withCtx(() => [
            (pageIndex.value === 0 && page.value.steps)
              ? (_openBlock(), _createBlock(Layout, {
                  key: 0,
                  title: variantTitle.value,
                  scrollDefaultSlot: true,
                  class: "onboarding-trial__inner--steps"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      class: "onboarding-trial__close onboarding-trial__close--body",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (__props.nextOnboardingPage && __props.nextOnboardingPage(...args)))
                    }, [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("span", { class: "iconfont iclose-thin" }, null, -1)
                    ]))]),
                    (_unref(trialByPlan15535Treatment)())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createElementVNode("div", _hoisted_4, [
                            _cache[8] || (_cache[8] = _createElementVNode("img", {
                              src: _imports_1,
                              class: "onboarding-trial__stars"
                            }, null, -1)),
                            (!trialPolicy.value?.trial_days)
                              ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_6, [
                              _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "onboarding-trial__period-title" }, "Annual plan", -1)),
                              _createElementVNode("div", _hoisted_7, [
                                _cache[6] || (_cache[6] = _createTextVNode(" Includes ", -1)),
                                _createElementVNode("strong", null, _toDisplayString(trialDays.value.annual) + "-day free trial", 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trialSteps.value.annual, (step, index) => {
                                return (_openBlock(), _createBlock(StepItem, {
                                  key: index,
                                  step: step,
                                  variant: "annual"
                                }, null, 8, ["step"]))
                              }), 128))
                            ])
                          ]),
                          _createVNode(Divider, { class: "onboarding-trial__divider" }),
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "onboarding-trial__period-title" }, "Monthly plan", -1)),
                              _createElementVNode("div", _hoisted_11, [
                                (trialDays.value.monthly > 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                      _cache[9] || (_cache[9] = _createTextVNode(" Includes ", -1)),
                                      _createElementVNode("strong", null, _toDisplayString(trialDays.value.monthly) + "-day free trial", 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_13, "No free trial included"))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trialSteps.value.monthly, (step, index) => {
                                return (_openBlock(), _createBlock(StepItem, {
                                  key: index,
                                  step: step,
                                  variant: "monthly"
                                }, null, 8, ["step"]))
                              }), 128))
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.value.steps, (step, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "onboarding-trial__step"
                            }, [
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("img", {
                                  src: _unref(getImage)(step.icon),
                                  class: "onboarding-trial__step-icon"
                                }, null, 8, _hoisted_17)
                              ]),
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("p", _hoisted_19, _toDisplayString(step.day), 1),
                                _createElementVNode("p", _hoisted_20, _toDisplayString(step.text), 1)
                              ])
                            ]))
                          }), 128))
                        ]))
                  ]),
                  _: 1
                }, 8, ["title"]))
              : (pageIndex.value === 1)
                ? (_openBlock(), _createBlock(Layout, {
                    key: 1,
                    title: variantTitle.value,
                    class: "onboarding-trial__inner--reminder"
                  }, {
                    aboveTitle: _withCtx(() => [
                      _createElementVNode("img", {
                        class: "onboarding-trial__image",
                        src: pageImage.value,
                        width: page.value.image?.width,
                        height: page.value.image?.height
                      }, null, 8, _hoisted_21)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "onboarding-trial__close onboarding-trial__close--body",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (__props.nextOnboardingPage && __props.nextOnboardingPage(...args)))
                      }, [...(_cache[11] || (_cache[11] = [
                        _createElementVNode("span", { class: "iconfont iclose-thin" }, null, -1)
                      ]))]),
                      (!_unref(trialByPlan15535Treatment)())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createElementVNode("p", _hoisted_23, " 🔔 " + _toDisplayString(reminderDate()), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true)
          ]),
          _: 1
        })),
    _createElementVNode("div", _hoisted_24, [
      (!_unref(wait).is('Loading'))
        ? (_openBlock(), _createBlock(AppButton, {
            key: 0,
            class: "onboarding-trial__button",
            onClick: buttonClick
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(trialByPlan15535Treatment)() ? 'Continue' : 'Start Free Trial'), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})